import * as React from 'react';

type Props = Omit<React.ComponentPropsWithoutRef<'svg'>, 'xmlns' | 'viewBox' | 'className'>;

// https://thenounproject.com/term/stats/1348932/
// Stats by Barracuda from the Noun Project
const Icon = (props: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="icon" {...props}>
    <g transform="translate(0,-952.36218)">
      <path d="m 7.0000001,960.36214 c -1.6569,0 -3,1.3431 -3,3 l 0,78.00006 c 0,1.6568 1.3432,3 3,3 l 85.9999999,0 c 1.6569,0 3,-1.3432 3,-3 0,-1.6569 -1.3431,-3 -3,-3 l -83,0 0,-75.00006 c 0,-1.6569 -1.3431998,-3 -2.9999998,-3 z M 67,977.36226 c -1.8106,-0.003 -3.223,1.68217 -3.1562,3.15625 0.082,1.57097 1.5852,2.92584 3.1562,2.84375 l 8.4688,0 -26.5938,25.00004 -9.5625,-7.9688 c -0.6047,-0.71919 -1.5625,-1.12625 -2.5,-1.06249 -0.6687,0.0481 -1.3184,0.32817 -1.8125,0.78129 l -20,17.9999 c -1.2284,1.0302 -1.3817,3.1179 -0.3125,4.3125 1.0693,1.1946 3.153,1.2635 4.3125,0.1563 l 18.0938,-16.2812 9.625,8.0313 c 1.0587,1.227 3.167,1.333 4.3437,0.2187 L 80,987.36226 l 0,9 c -0.022,1.58494 1.4149,3.03125 3,3.03125 1.5851,0 3.0224,-1.44631 3,-3.03125 l 0,-16 c -2e-4,-1.57075 -1.4292,-2.99984 -3,-3 z" />
    </g>
  </svg>
);

export default Icon;
